import React from 'react'
import { PageTitleProps } from './types'
import styles from './PageTitle.module.scss'
import cl from 'classnames'

const PageTitleComponent = (props: PageTitleProps) => {
  const { text, overEffect } = props

  return (
    <h1 className={cl(styles.container, { [styles.overEffect]: overEffect })}>
      {text}
    </h1>
  )
}

const PageTitle = PageTitleComponent
export { PageTitle }
